import { render } from "./Warning.vue?vue&type=template&id=2c580bb5"
const script = {}

import exportComponent from "/Volumes/Storage/WebDevelopment/Fintax/new-gitlab/pajak.io/frontend-library-component-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__